// extracted by mini-css-extract-plugin
export default {"cls1":"PaperContainer-cls1_Yoy","cls2":"PaperContainer-cls2_FqF PaperContainer-cls1_Yoy"};